import { Fragment, useCallback, useRef, useState } from 'react';
import { Tooltip } from '../Tooltip';
import { TextContainer, Subtitle, Title } from './styled';
const isTruncated = (element) => element !== null && element.offsetWidth < element.scrollWidth;
export function AvatarLabel(props) {
    const { title, subtitle, truncate, labelTooltip } = props;
    const titleRef = useRef(null);
    const subtitleRef = useRef(null);
    const [displayTooltip, setDisplayTooltip] = useState(false);
    const measureTruncation = useCallback(() => {
        setDisplayTooltip(isTruncated(titleRef.current) || isTruncated(subtitleRef.current));
    }, []);
    const tooltipTitle = (<Fragment>
      {title} {subtitle}
    </Fragment>);
    if (!title && !subtitle) {
        return null;
    }
    return (<Tooltip disabled={!displayTooltip} title={tooltipTitle} {...labelTooltip}>
      <TextContainer tabIndex={displayTooltip ? 0 : undefined} onMouseEnter={measureTruncation} onFocus={measureTruncation}>
        {title && (<Title $truncate={truncate} ref={titleRef}>
            {title}
          </Title>)}
        {subtitle && (<Subtitle $truncate={truncate} ref={subtitleRef}>
            {subtitle}
          </Subtitle>)}
      </TextContainer>
    </Tooltip>);
}
